import {Injectable} from '@angular/core';

import {UserDetailsComponent} from './users/user-details/user-details.component';


@Injectable()
export class UserEditGuardService  {

  constructor() {
  }

  canDeactivate(component: UserDetailsComponent): boolean {

    // true to deactivate the route
    // false to cancel the route deactivation
    // for more complex cases this could return an Observable
    if (component.userForm.dirty) {
      const userName = component.user.firstName + ' ' +
        component.user.lastName;
      return confirm(`Are you sure you want to leave the page before saving data for ${userName}`);
    }
    return true;
  }
}
